var cifMv = ["301 201", "<g fill='none'><path fill='#D21034' d='M.5.5h300v200H.5z'/><path fill='#007E3A' d='M50.5 50.5h200v100h-200z'/><circle cx='163' cy='100.5' r='33.333' fill='#FFF'/><circle cx='175.5' cy='100.5' r='33.333' fill='#007E3A'/></g>"];

export { cifMv };
